import { render, staticRenderFns } from "./configPromocionesOne.vue?vue&type=template&id=143f9ce6&scoped=true"
import script from "./configPromocionesOne.vue?vue&type=script&lang=js"
export * from "./configPromocionesOne.vue?vue&type=script&lang=js"
import style0 from "./configPromocionesOne.vue?vue&type=style&index=0&id=143f9ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143f9ce6",
  null
  
)

export default component.exports